import React from 'react'
import { SelfRegistrationModal } from './base-modal'
import {
  Typography,
  Divider,
  Box,
  Checkbox,
  FormControlLabel,
  Link
} from '@mui/material'
import { useStyles } from '../style'

export const SelfRegistrationDisabledModal = ({
  open,
  handleClose,
  handleProceed,
  id
}) => {
  const classes = useStyles()
  const [show, setShow] = React.useState(false)

  const handleModalClose = () => {
    handleClose()

    show && localStorage.setItem(id, 'no')
  }

  const handleSubmit = () => {
    // Toggle switch to false to disable self registration and close the modal.
    handleProceed(false)
    handleModalClose()
  }

  return (
    <SelfRegistrationModal
      id={id}
      open={open}
      header={
        <>
          <Typography variant='h6'>Disable Self Registration</Typography>
          <Divider className={classes.divider} />
        </>
      }
      body={
        <>
          <Typography marginBottom={3}>
            By switching off this feature, you are disabling domain-restricted
            self-registration entirely. New users will no longer be able to
            register themselves, and all new registrations will be restricted.
          </Typography>
          <Typography marginBottom={3}>
            <strong>Remember:</strong> To turn it back on, simply turn on this
            toggle again.
          </Typography>

          <Typography marginBottom={3}>
            <strong>Note:</strong> Registered users will still be able to log in
          </Typography>

          <Box marginBottom={3}>
            <FormControlLabel
              control={
                <Checkbox
                  data-test={`${id}-checkbox`}
                  value={show}
                  onChange={() => setShow((state) => !state)}
                />
              }
              label="Don't show this message again"
            />
          </Box>
        </>
      }
      footer={
        <Box className={classes.modalFooterActions}>
          <Link
            underline='hover'
            data-test={`${id}-close-btn`}
            className={classes.modalFooterBtn}
            onClick={handleModalClose}
          >
            Close
          </Link>
          <Link
            underline='hover'
            data-test={`${id}-proceed-btn`}
            className={classes.modalFooterBtn}
            onClick={handleSubmit}
          >
            Proceed
          </Link>
        </Box>
      }
      handleClose={handleClose}
    />
  )
}
